import React from 'react'
import { useQuery } from '@apollo/client'
import { NotFound } from '@fs/zion-router'

import { PageSkeleton } from '../../components/_helper-components'
import OverlayPreview from './OverlayPreview'
import SharedModulesContent from './SharedModulesContent'
import SharedSectionsContent from '../../pages/SharedSectionsContent/SharedSectionsContent'

import OVERLAY_QUERY from './queries/Overlay.gql'
import POPOVER_QUERY from './queries/Popover.gql'
import SHARED_MODULES_CONTENT_QUERY from './queries/SharedModulesContent.gql'
import SHARED_SECTIONS_CONTENT_QUERY from '../../pages/SharedSectionsContent/SharedSectionsContent.gql'

const queryMap = {
  Overlay: OVERLAY_QUERY,
  Popover: POPOVER_QUERY,
  SharedModulesContent: SHARED_MODULES_CONTENT_QUERY,
  SharedSectionsContent: SHARED_SECTIONS_CONTENT_QUERY,
}

const componentMap = {
  Overlay: OverlayPreview,
  Popover: OverlayPreview,
  SharedModulesContent,
  SharedSectionsContent,
}

export type Typename = 'Overlay' | 'Popover' | 'SharedModulesContent' | 'SharedSectionsContent'

type BrightspotPreviewProps = {
  typename: Typename
  previewId: string
  site: string
}

export default function BrightspotPreview({ typename, previewId, site }: BrightspotPreviewProps): JSX.Element {
  const { loading, error, data } = useQuery(queryMap?.[typename], {
    variables: { id: previewId },
    context: { apiName: site },
  })

  if (loading) return <PageSkeleton />

  if (error) {
    return <ErrorDetails error={error} previewId={previewId} />
  }

  return componentMap?.[typename](data?.[typename])
}

export function ErrorDetails({ error, previewId }: { error: Error; previewId?: string }): JSX.Element {
  console.error(`ErrorDetails(error=${JSON.stringify(error)}, previewId=${previewId})`)
  if (!previewId) {
    return <NotFound />
  }
  return (
    <div>
      <h1>Error</h1>
      <p>previewId: {previewId}</p>
      <p>{error.message}</p>
    </div>
  )
}
